import { createContext, useContext, ReactNode } from "react";
import { Outlet } from "react-router-dom";

import useFetchCards from "../hooks/useFetchCards";

interface CardsContextValue {
  cards: API.Card[];
  isLoading: boolean;
}

const defaultValue: CardsContextValue = {
  cards: [],
  isLoading: false,
};

const CardsContext = createContext<CardsContextValue>(defaultValue);

interface CardsContextProviderProps {
  children: ReactNode;
}

export const CardsContextProvider = ({
  children,
}: CardsContextProviderProps): JSX.Element => {
  const contextValue = useFetchCards();

  return (
    <CardsContext.Provider value={contextValue}>
      {children}
    </CardsContext.Provider>
  );
};

export const useCards = (): CardsContextValue => useContext(CardsContext);

export const CardsLayout = (): JSX.Element => (
  <CardsContextProvider>
    <Outlet />
  </CardsContextProvider>
);

export default CardsContext;
